import { Chart } from '@frontend/chart/types';

export const FILL_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Safety gloves', data: [{ label: 'full_period', value: 112 }] },
        { name: 'Ear protection', data: [{ label: 'full_period', value: 105 }] },
        { name: 'Safety glasses', data: [{ label: 'full_period', value: 98 }] },
        { name: 'Work boots', data: [{ label: 'full_period', value: 91 }] },
        { name: 'Hi-vis vest', data: [{ label: 'full_period', value: 78 }] },
        { name: 'Hard hat', data: [{ label: 'full_period', value: 65 }] },
        { name: 'Dust mask', data: [{ label: 'full_period', value: 42 }] },
        { name: 'Knee pads', data: [{ label: 'full_period', value: 33 }] }
    ]
};
